module.exports = __webpack_public_path__ + "824f571139f63e1460af796d6aeed84e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-happy.png
// module id = 2051
// module chunks = 4